module.exports = __webpack_public_path__ + "static/media/6.ff5307e8.JPG";